// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type ToolListe, ToolStage } from "../../api";
import { useSearchTools as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export type ToolsQuery = {
  search?: string;
  stage?: ToolStage;
  mandantId?: string;
  page?: number;
  limit?: number;
  sort?: string;
};

export function useToolsQueryKey(query: ToolsQuery = {}): QueryKey {
  return ["api", "v1", "tools", query];
}

export function useTools(
  query: ToolsQuery = {},
  options: Omit<
    UseQueryOptions<ToolListe, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): ToolListe {
  const getter = useGetter();
  return useQuery(useToolsQueryKey(query), () => getter(query), options).data!;
}
